import { useState } from 'react';
import { C } from '../components/roadmap/shared';
import { PROJECT_SCOPE } from '../data/sessions';
import ScopeTab from '../components/roadmap/ScopeTab';
import ArchTab from '../components/roadmap/ArchTab';
import SessionsTab from '../components/roadmap/SessionsTab';
import RoadmapTab from '../components/roadmap/RoadmapTab';
import FeatureRequestsTab from '../components/roadmap/FeatureRequestsTab';
import InfraTab from '../components/roadmap/InfraTab';
import LegalTab from '../components/roadmap/LegalTab';
import TestingTab from '../components/roadmap/TestingTab';
import AlignmentTab from '../components/roadmap/AlignmentTab';
import FileArchTab from '../components/roadmap/FileArchTab';

const Badge = ({ color, children }) => (
  <span style={{
    background: color + '22', color, border: '1px solid ' + color + '44',
    borderRadius: 4, padding: '2px 8px', fontSize: 11, fontWeight: 700,
    letterSpacing: '0.05em', whiteSpace: 'nowrap', display: 'inline-block',
  }}>{children}</span>
);

const TABS = ['Project Scope', 'Architecture', 'Sessions', 'Roadmap', 'Feature Requests', 'Infrastructure', 'Legal Rules', 'Testing & QA', 'Claude Alignment', 'File Architecture'];

export default function RoadmapPage({ user, token, navigateTo, isSuperAdmin }) {
  const [activeTab, setActiveTab] = useState('Project Scope');

  if (!isSuperAdmin) { navigateTo('home'); return null; }

  // Read live state from PROJECT_SCOPE — never hardcode these values in this shell
  const sessionBadge = PROJECT_SCOPE.currentSession.split(' — ')[0];
  const head         = PROJECT_SCOPE.lastCommit;
  const smoke        = PROJECT_SCOPE.smokeCount;

  return (
    <div style={{ background: C.bg, minHeight: '100vh', fontFamily: 'system-ui, sans-serif', color: C.text }}>
      <div style={{ background: C.card, borderBottom: '1px solid ' + C.border,
        padding: '16px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        flexWrap: 'wrap', gap: 16 }}>
        <div style={{ flex: '1 1 320px', minWidth: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
            <span style={{ color: C.green, fontWeight: 800, fontSize: 20 }}>MarketPulze</span>
            <Badge color={C.green}>LIVE</Badge>
            <Badge color={C.info}>{sessionBadge}</Badge>
            <Badge color={C.info}>10 tabs</Badge>
            <Badge color={C.green}>smoke {smoke}</Badge>
            <Badge color={C.danger}>Super Admin Only</Badge>
          </div>
          <div style={{ color: C.muted, fontSize: 11, marginTop: 4 }}>
            Architecture + Roadmap Reference · May 2026 · HEAD: {head} · Smoke: {smoke} · sessions.js = thin aggregator (4-file arch)
          </div>
        </div>
        <div style={{ textAlign: 'right', flex: '1 1 240px', maxWidth: 'clamp(220px, 32vw, 480px)' }}>
          <div style={{ color: C.muted, fontSize: 11, lineHeight: 1.5, overflowWrap: 'break-word' }}>
            {PROJECT_SCOPE.currentSession}
          </div>
          <button onClick={() => navigateTo('home')} style={{
            marginTop: 6, background: 'none', border: '1px solid ' + C.border,
            color: C.muted, borderRadius: 6, padding: '4px 12px', cursor: 'pointer', fontSize: 11,
          }}>Back to Home</button>
        </div>
      </div>
      <div style={{ background: C.card, borderBottom: '1px solid ' + C.border,
        padding: '0 24px', display: 'flex', gap: 2, overflowX: 'auto' }}>
        {TABS.map(tab => (
          <button key={tab} onClick={() => setActiveTab(tab)} style={{
            background: 'none', border: 'none', cursor: 'pointer', padding: '12px 14px',
            color: activeTab === tab ? C.green : C.muted,
            borderBottom: '2px solid ' + (activeTab === tab ? C.green : 'transparent'),
            fontSize: 11, fontWeight: 700, letterSpacing: '0.04em', fontFamily: 'inherit',
            whiteSpace: 'nowrap', flexShrink: 0,
          }}>{tab.toUpperCase()}</button>
        ))}
      </div>
      <div style={{ padding: 24, margin: '0 auto' }}>
        {activeTab === 'Project Scope'     && <ScopeTab />}
        {activeTab === 'Architecture'      && <ArchTab />}
        {activeTab === 'Sessions'          && <SessionsTab />}
        {activeTab === 'Roadmap'           && <RoadmapTab />}
        {activeTab === 'Feature Requests'  && <FeatureRequestsTab />}
        {activeTab === 'Infrastructure'    && <InfraTab />}
        {activeTab === 'Legal Rules'       && <LegalTab />}
        {activeTab === 'Testing & QA'      && <TestingTab />}
        {activeTab === 'Claude Alignment'  && <AlignmentTab />}
        {activeTab === 'File Architecture' && <FileArchTab />}
      </div>
    </div>
  );
}
